import { useRef, Children } from 'react';

export function Switch({
    rootClassName = '',
    children,
    ...rest
}: React.PropsWithChildren<{ rootClassName?: string } & React.InputHTMLAttributes<HTMLInputElement>>) {
    const ref = useRef<HTMLInputElement>(null);

    if (Children.count(children) !== 2) {
        throw Error('Switch component should have 2 child');
    }

    const [optionA, optionB] = Children.toArray(children);

    return (
        <div
            className={
                'relative w-[110px] h-[24px] flex items-center justify-between rounded-[4px] bg-midnight text-ash-grey select-none cursor-pointer p-[2px] ' +
                rootClassName
            }
            onClick={() => {
                ref.current?.click();
            }}
        >
            <input ref={ref} type='checkbox' className='peer hidden' {...rest} />
            <span className='w-[54px] flex justify-center items-center rounded-[4px] transition bg-indigo-bright peer-checked:bg-midnight px-[8px]'>
                {optionA}
            </span>
            <span className='w-[54px] flex justify-center items-center rounded-[4px] transition bg-midnight peer-checked:bg-indigo-bright px-[8px]'>
                {optionB}
            </span>
        </div>
    );
}

// Switch.FirstOption = function ({ children }: React.PropsWithChildren) {
//     return <>{children}</>;
// };

// Switch.Option = function ({ children }: React.PropsWithChildren) {
//     return <>{children}</>;
// };
